import { Injectable } from '@angular/core';
import { PosHttpService } from '../services/pos.http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor(
    private posHttpSvcs:PosHttpService,
  ) { }

  getHeader():Observable<any>{
   return this.posHttpSvcs.authGet('v1/auth/appDetails','appDetails');
 }
}
